import React from 'react'
import PropTypes from 'prop-types'

const PageWrapper = ({ children }) => (
  <div className='content-wrapper bg-light'>
    <div className='content-wrapper-inner position-relative bg-white p-5'>
      <div className='col-12 my-5'>
        {children}
      </div>
    </div>
  </div>
)

PageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.element
    ])),
    PropTypes.element
  ])
}

export default PageWrapper
